import React from 'react';
import '../styles/ContactSection.css';

const ContactSection: React.FC = () => {
  return (
    <section className="contact-section">
      <h2>Kapcsolat</h2>
      <div className="contact-locations">
        <div className="location-card">
          <h3>NailsRoom</h3>
          <div className="card-content">
            <div className="contact-info">
              <div className="info-item">
                <i className="icon">📍</i>
                <p>1164 Budapest<br />Vidámvásár u. 16.</p>
              </div>
              <div className="info-item">
                <i className="icon">📞</i>
                <p>+36 30 248 5090</p>
              </div>             
              <div className="info-item opening-hours"> 
                <i className="icon">🕒</i>               
                <p>Nyitvatartás előzetes telefonos bejelentkezés alapján!</p>
              </div>
            </div>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2695.497758200882!2d19.22194904010873!3d47.519673454327226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDfCsDMxJzEwLjgiTiAxOcKwMTMnMTkuMCJF!5e0!3m2!1sen!2shu!4v1718281882358!5m2!1sen!2shu&z=16"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Location 1 Map"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="location-card">
          <h3>Teola Salon</h3>
          <div className="card-content">
            <div className="contact-info">
              <div className="info-item">
                <i className="icon">📍</i>
                <p>1134 Budapest<br />Lőportár köz 5.</p>
              </div>
              <div className="info-item">
                <i className="icon">📞</i>
                <p>+36 30 248 5090</p>
              </div> 
              <div className="info-item opening-hours">
                <i className="icon">🕒</i>
                <p>Online időpont foglalás <a href="https://partner.notino.com/api/b2c/redirect/salons/detail?salonID=fd62acbd-50f1-467a-9dc4-0ccd41cb9451&utm_source=salon_mkt&utm_medium=qr&utm_campaign=booking_promo&utm_content=fd62acbd-50f1-467a-9dc4-0ccd41cb9451">itt</a> lehetséges.</p>
              </div>
            </div>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1512.239448142427!2d19.066698764750132!3d47.51904238105882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741db7d545404b7%3A0x8a79847c603d6320!2sTeola%20Salon!5e0!3m2!1sen!2shu!4v1782825413780!5m2!1sen!2shu"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Location 2 Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 